module.exports = __webpack_public_path__ + "img/live_weixin_ios.246d2af5.png";